export default "__VITE_ASSET__GNi6dF15__"